import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";

export const useDragScroll = (elementId: string) => {
  let element: HTMLElement;
  let pos = { top: 0, left: 0, x: 0, y: 0 };
  const store = useTimelineMapStore();

  const mouseDownHandler = (e: MouseEvent) => {
    element.style.cursor = 'grabbing';
    element.style.userSelect = 'none';

    pos = {
      left: element.scrollLeft,
      top: element.scrollTop,

      x: e.clientX,
      y: e.clientY,
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };

  const mouseMoveHandler = (e: MouseEvent) => {
    store.isDragging = true;
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;

    element.scrollTop = pos.top - dy;
    element.scrollLeft = pos.left - dx;
  };

  const mouseUpHandler = () => {
    // Add some delay to prevent the click event when the user drags the timeline
    setTimeout(() => {
      store.isDragging = false;
    }, 1);

    element.style.cursor = 'grab';
    element.style.removeProperty('user-select');

    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
  };

  const scrollHorizontal = (e: WheelEvent) => {
    e.preventDefault();
    
    if (e.deltaY > 0) {
      element.scrollLeft += 50;
    } else {
      element.scrollLeft -= 50;
    }
  }

  const init = () => {
    element = document.getElementById(elementId) as HTMLElement;

    if (element == null) {
      return;
    }

    element.style.cursor = 'grab';
    element.addEventListener('mousedown', mouseDownHandler);
    element.addEventListener('wheel', scrollHorizontal, { passive: false });
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
  });
}